import { SignIn as ClerkSignIn, useAuth } from "@clerk/react";
import { Link, Navigate } from "react-router-dom";
import { AuthMarketingLayout } from "@/components/AuthMarketingLayout";
import { AuthLoadingState } from "@/features/auth/ProtectedRoute";

export function SignIn() {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return <AuthLoadingState />;
  }

  if (isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <AuthMarketingLayout
      title="Sign in"
      accountSwitch={
        <>
          New here?{" "}
          <Link to="/sign-up" className="font-semibold text-indigo-700 hover:text-indigo-900">
            Create an account
          </Link>
        </>
      }
    >
      <ClerkSignIn
        routing="path"
        path="/sign-in"
        signUpUrl="/sign-up"
        fallbackRedirectUrl="/dashboard"
        appearance={{
          elements: {
            rootBox: "w-full",
            cardBox: "w-full shadow-none",
            card: "w-full shadow-none",
          },
        }}
      />
    </AuthMarketingLayout>
  );
}
